import React, {useEffect, useState} from "react";
import "../../../../../Assets/Styles/SimpleTextInput.scss";

const SimpleTextInputNoLabel = (props) => {
  const [InputValue, setInputValue] = useState();

  useEffect(() => {
    setTimeout(() => {
      if (
        document.getElementById(props.Id) !== null &&
        document.getElementById(props.Id).value.length > 0
      ) {
        addFilledState();
        document
          .getElementById(props.Id + "-placeholder")
          .classList.add("hidden");
      }
    }, 100);
  }, []);

  useEffect(() => {
    if (Number(InputValue) > Number(props.MaxValue)) {
      setInputValue(Number(props.MaxValue))
    }
  }, [props.MaxValue])

  const handleBlurElement = (e) => {
    document
      .getElementById(props.Id + "-label-holder")
      .classList.remove("wrong");
    if (e.target.value.length > 0) {
      addFilledState();
    } else {
      removeActiveState();
      removeFilledState();
    }
  };
  const addActiveState = () => {
    document.getElementById(props.Id).classList.add("active");
    removeFilledState();
  };
  const removeActiveState = () => {
    document.getElementById(props.Id).classList.add("filled");
    document.getElementById(props.Id).classList.remove("active");
  };
  const addFilledState = () => {
    document.getElementById(props.Id).classList.add("filled");
    document.getElementById(props.Id).classList.remove("active");
  };
  const removeFilledState = () => {
    document.getElementById(props.Id).classList.remove("filled");
  };
  const handleChange = (e) => {
    let Value = e.target.value;
    setInputValue(Value)
    if (Value.length > 0) {
      document
        .getElementById(props.Id + "-placeholder")
        .classList.add("hidden");
    } else {
      document
        .getElementById(props.Id + "-placeholder")
        .classList.remove("hidden");
    }
    props.ChangeEvent();
  };
  return (
    <label id={props.Id + "-label-holder"} className="cx-simple-text-input">
      <p className="placeholder" id={props.Id + "-placeholder"}>
        {props.PlaceHolder}
      </p>
      <input
        onFocus={() => addActiveState()}
        onBlur={(e) => handleBlurElement(e)}
        type={props.Type ? props.Type : "text"}
        id={props.Id}
        className="cx-text-input"
        onChange={(e) => handleChange(e)}
        autoComplete="off"
        defaultValue={props.InitialValue ? props.InitialValue : ""}
        max={props.MaxValue}
        min={0}
        value={InputValue}
        onKeyUp={(e) => {
          if (props.Type === "number") {
            const currentValue = Number(e.target.value)
            const maxValue = Number(props.MaxValue)
            const minValue = 0

            if (maxValue && currentValue > maxValue) {
              setInputValue(maxValue)
            } else if (currentValue < minValue) {
              setInputValue()
            }

          }
        }}
      />
      <p className="validation-message" id={props.Id + "-validation"}>
        {props.ValidationMessage}{" "}
      </p>
    </label>
  );
};
export default SimpleTextInputNoLabel;
